import Model from "../../Model/Model";
import Overlay from "../../Overlay";
import React from 'react';
const ModelOverlay = props => {
    const { footer, title, onClose, onClickIn, classes } = props;
    return React.createElement(Overlay, null,
        React.createElement("div", { className: "model-overlay", onClick: () => onClickIn && onClickIn() },
            React.createElement(Model, { footer: footer, title: title, onClose: onClose, classes: classes }, props.children)));
};
export default ModelOverlay;
